import util from '../util'

let controller = 'FinalidadesTransf'

export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post', 'put', 'persist', 'delete']), {
  BuscarTipoFinalidades: function(search) {
    return util.Axios.GetAll(controller, search)
  },
})